<div class="lista-de-servicos">

    <h4>Rateios programas/projetos:</h4>
    <div class="mat-elevation-z2">
      <mat-progress-bar mode="indeterminate" *ngIf="!loadingCompleto"></mat-progress-bar>
      <table mat-table matSort matSortDisableClear [dataSource]="dataSource" class="coloridas">
  
        <ng-container matColumnDef="programaprojeto">
            <th mat-header-cell *matHeaderCellDef style="width: 50%"> Projeto/Programa </th>
            <td mat-cell *matCellDef="let element"> 
                {{element.nomeProgramaProjeto}}                 
            </td>
        </ng-container>

        <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef style="width: 20%">Valor rateio</th>
            <td mat-cell *matCellDef="let element"> {{ element.valor | currency: 'BRL' }} </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="colunasVisiveis"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasVisiveis;"></tr>
      </table>
    </div>
  </div>
  